import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { Grid, ListItemIcon, ListSubheader } from '@mui/material'
import DeleteHardware from './DeleteHardware'
import EditHardware from './EditHardware'
import DeveloperBoard from '@mui/icons-material/DeveloperBoard'
import { JSONSchema7 } from 'json-schema'
import { Hardware } from '../../interfaces/hardware'
import CreateHardware from './CreateHardware'
import schema from '../../schemas/hardware.json'

export interface Props {
  disabled: boolean
  data: Hardware[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function HardwareList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Hardware'}
            <CreateHardware disabled={disabled} data={data} schema={schema as JSONSchema7} setData={setData} />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: Hardware, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditHardware disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeleteHardware disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <DeveloperBoard />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`maximum grid power: ${obj.max_power_grid / 1000} kW`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
